const LANGUAGE_CONSTANT: Record<string, string> = {
  de: 'de',
  en: 'en',
  es: 'es',
  fr: 'fr',
  it: 'it',
  nl: 'nl',
  pl: 'pl',
  pt: 'pt',
  tr: 'tr'
};

const SESSION_VARIABLE = 'baseUrlSet';

export function currentLanguage(toggledLang: string): string {
  return LANGUAGE_CONSTANT[toggledLang] || LANGUAGE_CONSTANT['en'];
}

export function languageSelection(): string | null {
  //Reading language from local storage
  const sessionLang = window.localStorage.getItem(SESSION_VARIABLE);
  if (sessionLang === null) {
    return LANGUAGE_CONSTANT.en;
  } else {
    return currentLanguage(sessionLang.split('/').pop()?.slice(0, -1) || 'en');
  }
}

export const getLangFromUrl = (): string => {
  const parts = window.location.pathname.split('/');
  const lang = parts[3];

  if (Object.prototype.hasOwnProperty.call(LANGUAGE_CONSTANT, lang)) {
    return lang;
  }

  return 'en';
};

export const getLocaleFromUrl = (): { lang: string; country: string } => {
  const parts = window.location.pathname.split('/');
  const lang = parts[3];
  const country = parts[2];

  return {
    lang: Object.prototype.hasOwnProperty.call(LANGUAGE_CONSTANT, lang) ? lang : 'en',
    country: country || 'us'
  };
};
